













































































import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import { RecordType, RecordTypeAdditionalInfo, RecordTypeFormItem } from '@/modules/RecordType/interfaces/record-type'
import { Contact } from '@/modules/Contact/interfaces/contact'
import ContactDialog from '@/modules/Contact/scripts/contact-dialog'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard
  }
})
export default class ContactDetailDetail extends mixins(ContactDialog) {
  @Prop({ type: Object as () => Contact }) readonly contact!: Contact
  @Prop({ type: Object as () => RecordType }) readonly recordType!: RecordType

  contactInfoCard = [
    { title: 'Phone', content: '-' },
    { title: 'Extension', content: '-' },
    { title: 'Mobile', content: '-' },
    { title: 'Other Phone', content: '-' },
    { title: 'Email', content: '-' },
    { title: 'Other Email', content: '-' },
    { title: 'Fax', content: '-' },
    { title: 'Other Address Country', content: '-' },
    { title: 'Mailing Address Country', content: '-' },
    { title: 'Other Address State', content: '-' },
    { title: 'Mailing Address State', content: '-' },
    { title: 'Other Address City', content: '-' },
    { title: 'Mailing Address City', content: '-' },
    { title: 'Other Address Street', content: '-' },
    { title: 'Mailing Address Street', content: '-' },
    { title: 'Other Address Zip/Postal Code', content: '-' },
    { title: 'Mailing Address Zip/Postal Code', content: '-' }
  ]

  sourceInfoCard = [
    { title: 'Source', content: '-', emphasize: true }
  ]

  additionalInfoCards: {
    title: string;
    items: {[key: string]: string;}[]
  }[] = []

  get accountRoute () {
    return {
      name: 'AccountDetailDetail',
      params: {
        id: this.contact.accountName.id
      }
    }
  }

  @Watch('contact', { deep: true })
  onContactUpdated (val: Contact) {
    this.contactInfoCard[0].content = val.phone ? formatPhoneNumber(val.phone, val.countryCode, val.extensionNumber) : '-'
    this.contactInfoCard[1].content = val.extension || '-'
    this.contactInfoCard[2].content = val.mobile ? formatPhoneNumber(val.mobile, val.mobileCountryCode, val.mobileExtensionNumber) : '-'
    this.contactInfoCard[3].content = val.otherPhone ? formatPhoneNumber(val.otherPhone, val.otherCountryCode, val.otherExtensionNumber) : '-'
    this.contactInfoCard[4].content = val.email || '-'
    this.contactInfoCard[5].content = val.otherEmail || '-'
    this.contactInfoCard[6].content = val.fax ? formatPhoneNumber(val.fax, val.faxCountryCode, val.faxExtensionNumber) : '-'
    this.contactInfoCard[7].content = val.mailingAddressCountry || '-'
    this.contactInfoCard[8].content = val.otherAddressCountry || '-'
    this.contactInfoCard[9].content = val.mailingAddressState || '-'
    this.contactInfoCard[10].content = val.otherAddressState || '-'
    this.contactInfoCard[11].content = val.mailingAddressCity || '-'
    this.contactInfoCard[12].content = val.otherAddressCity || '-'
    this.contactInfoCard[13].content = val.mailingAddressStreet || '-'
    this.contactInfoCard[14].content = val.otherAddressStreet || '-'
    this.contactInfoCard[15].content = val.mailingAddressPostalCode || '-'
    this.contactInfoCard[16].content = val.otherAddressPostalCode || '-'

    this.sourceInfoCard[0].content = val.source
      ? val.source.name
      : '-'

    this.udpateAddtionalInfo(val.additionalInfoStr)
  }

  mounted () {
    this.onContactUpdated(this.contact)
  }

  udpateAddtionalInfo (val: string) {
    const additionalInfo = JSON.parse(val)
    const recordTypeAddionalInfo = this.recordType.additionalInfo
    this.additionalInfoCards = []

    recordTypeAddionalInfo.map((info: RecordTypeAdditionalInfo) => {
      const { items, title } = info
      const _items = items.map((item: RecordTypeFormItem) => {
        return {
          title: item.name,
          content: additionalInfo[item.keyName] || '-'
        }
      })
      this.additionalInfoCards.push({
        title: title,
        items: _items
      })
    })
  }

  routeToProducerDetail () {
    return {
      name: 'ProducerDetailDetail',
      params: {
        id: this.contact.source.id + ''
      }
    }
  }
}
